const SelectOption = function (label = '', value = '', isDisabled = false) {
  this.label = label;
  this.value = value;
  this.isDisabled = isDisabled;
};

export default SelectOption;